import { useCurrentAuthSession } from '@/context/AuthContext';
import { useUserInfo } from '@/features/_data/useUserInfo';
import { RETAIL_API_URL } from '../../utils/envConfig';
import { fetcher } from './fetcher';
import { fetchUnitData } from '../features/_data/useUnitData';

/**
 * Hook to dispatch a unit to the player by preparing and sending necessary data to the electron process
 * @returns {[Function, boolean]} A tuple with the dispatch function and loading state
 */
export const useDispatchStartPlayer = () => {
  const { user } = useCurrentAuthSession();
  const { data: userInfo } = useUserInfo();

  const dispatchStartPlayer = async (unitId: string) => {
    try {
      const unitContent = await fetcher(
        `${RETAIL_API_URL}/players/contentPayload?unitId=${unitId}&version=2&shouldReturnScript=true`,
      );
      const { homeTimer } = await fetchUnitData(
        unitId,
        user?.uid,
        userInfo?.customer,
      );

      window.electron.ipcRenderer.sendMessage('setupPlayer', {
        unitId,
        unitContent,
        homeTimer,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return dispatchStartPlayer;
};
